import styled from "styled-components";

export const DeliveryDate = styled.span`
  color: ${({ theme }) => theme.colors.text.complementary};
  font-size: ${({ theme }) => theme.fonts.fontSize.ft16};
`;
